var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_10x10_flag_photo",
    "data-name": "10x10 flag photo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4644",
    "data-name": "Rectangle 4644",
    width: 10,
    height: 10,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_275",
    "data-name": "Mask Group 275",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_35",
    "data-name": "Layer 35",
    transform: "translate(-0.714 -0.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21274",
    "data-name": "Path 21274",
    d: "M10.714,7.825V9.318a.686.686,0,0,1-.682.682H7.111a.686.686,0,0,1-.682-.682V7.825a.686.686,0,0,1,.682-.682h1.1V6.071h-5V7.143h1.1A.686.686,0,0,1,5,7.825V9.318A.686.686,0,0,1,4.318,10H1.4a.686.686,0,0,1-.682-.682V7.825A.686.686,0,0,1,1.4,7.143H2.5V6.071a.714.714,0,0,1,.714-.714H5.357V4.286h-1.1A.686.686,0,0,1,3.571,3.6V2.111a.686.686,0,0,1,.682-.682H7.175a.686.686,0,0,1,.682.682V3.6a.686.686,0,0,1-.682.682h-1.1V5.357H8.214a.714.714,0,0,1,.714.714V7.143h1.1a.686.686,0,0,1,.682.682Z",
    fill: "#8e8e8e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.742cd2bf3c8ecbb9f4368b60723d74b0.svg";
export { ForwardRef as ReactComponent };